import { router } from 'expo-router'

export const adminMenuItems = [
  {
    name: 'UI Elements',
    callback: () => router.navigate('/dev/ui'),
  },
  {
    name: 'Dev Router',
    callback: () => router.navigate('/dev/router'),
  },
  {
    name: 'Optical Measure',
    callback: () => router.navigate('/dev/optical-measure'),
  },
].filter((item) => !!item)

export const devMenuItems = [
  {
    name: 'Admin panel',
    callback: () => router.navigate('/admin'),
  },
  {
    name: 'Cofidis Monthly Application',
    callback: () => router.navigate('/dev/cofidis-monthly-application'),
  },
  {
    name: 'Measurements UI',
    callback: () => router.navigate('/dev/measurements'),
  },
]
